import React from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  Link,
  Divider
} from '@mui/material';

const Footer = () => {
  return (
    <Box 
      component="footer" 
      sx={{ 
        bgcolor: 'primary.main',
        color: 'white', 
        py: 6, 
        mt: 'auto',
        borderTop: '4px solid #ff7043'
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ 
          display: 'grid', 
          gridTemplateColumns: { xs: '1fr', md: '2fr 1fr 1fr' },
          gap: 4,
          mb: 4
        }}>
          {/* Main Info */}
          <Box>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700, color: '#ecf0f1' }}>
              PARTIDUL SOCIAL DEMOCRAT EUROPEAN
            </Typography>
            <Typography variant="body2" sx={{ color: '#bdc3c7', lineHeight: 1.6, mb: 2 }}>
              Platforma oficială pentru petițiile cetățenilor europeni. Vocea ta contează în construirea unei Europe sociale și democratice.
            </Typography>
            <Typography variant="body2" sx={{ color: '#95a5a6', fontSize: '0.875rem' }}>
              Înregistrat conform legislației europene pentru organizații politice
            </Typography>
          </Box>

          {/* Links Rapide */}
          <Box>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#ecf0f1', mb: 2 }}>
              Links Utile
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link 
                href="https://psde.md" 
                target="_blank"
                rel="noopener noreferrer"
                sx={{ 
                  color: '#bdc3c7',
                  textDecoration: 'none',
                  fontSize: '0.875rem',
                  transition: 'color 0.2s',
                  '&:hover': { color: '#3f51b5' }
                }}
              >
                Site oficial PSDE
              </Link>
              <Link 
                href="/admin/login" 
                sx={{ 
                  color: '#bdc3c7',
                  textDecoration: 'none',
                  fontSize: '0.875rem',
                  transition: 'color 0.2s',
                  '&:hover': { color: '#3f51b5' }
                }}
              >
                Panou administrativ
              </Link>
            </Box>
          </Box>

          {/* Legal */}
          <Box>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#ecf0f1', mb: 2 }}>
              Informații Juridice
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link 
                href="/privacy" 
                sx={{ 
                  color: '#bdc3c7',
                  textDecoration: 'none',
                  fontSize: '0.875rem',
                  transition: 'color 0.2s',
                  '&:hover': { color: '#3f51b5' }
                }}
              >
                Politica de confidențialitate
              </Link>
              <Link 
                href="/terms" 
                sx={{ 
                  color: '#bdc3c7',
                  textDecoration: 'none',
                  fontSize: '0.875rem',
                  transition: 'color 0.2s',
                  '&:hover': { color: '#3f51b5' }
                }}
              >
                Termeni și condiții
              </Link>
              <Link 
                href="/gdpr" 
                sx={{ 
                  color: '#bdc3c7',
                  textDecoration: 'none',
                  fontSize: '0.875rem',
                  transition: 'color 0.2s',
                  '&:hover': { color: '#3f51b5' }
                }}
              >
                Conformitate GDPR
              </Link>
            </Box>
          </Box>
        </Box>

        <Divider sx={{ bgcolor: 'rgba(255,255,255,0.2)', mb: 3 }} />

        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          flexDirection: { xs: 'column', md: 'row' },
          gap: 2
        }}>
          <Typography variant="body2" sx={{ color: '#95a5a6', fontSize: '0.875rem' }}>
            © {new Date().getFullYear()} Partidul Social Democrat European. Toate drepturile rezervate.
          </Typography>
          <Typography variant="body2" sx={{ color: '#7f8c8d', fontSize: '0.75rem' }}>
            Versiunea 1.0 | Ultima actualizare: {new Date().toLocaleDateString('ro-RO')}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
